class PromoModal extends HTMLElement {
  connectedCallback() {
    const MODAL_ID = 'promo-modal';
    const LS_KEY = 'promo-modal-last-shown';

    const delay = Number(this.dataset.delay) || 0;
    const showAgainMs = Number(this.dataset.showAgain) || 0;

    const schedule = () => {
      const lastShown = Number(localStorage.getItem(LS_KEY)) || 0;

      if (lastShown && showAgainMs > 0 && Date.now() - lastShown < showAgainMs) return;

      setTimeout(() => {
        localStorage.setItem(LS_KEY, String(Date.now()));
        window.openModal(MODAL_ID);
      }, delay);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', schedule, { once: true });
    } else {
      schedule();
    }
  }
}

customElements.define('promo-modal', PromoModal);
